<template>
  <!-- 自适应-px写法-会导致和跳转过去的长得不一样 -->
  <header class="app-header" style="background-color: #145786; height: 63px">
    <div class="app-header__logo">
      <a :href="activeku" style="display: flex">
        <img
          src="../../assets/iamges/logo1.jpg"
          class="logo"
          alt=""
          style="height: 37px; width: 117px"
        />

        <div class="splitLines"></div>
        <h3 class="app-title" style="font-size: 24px; left: 133px">
          {{ titleName() }}
        </h3>
      </a>
      <div class="rightNavs">
        <div class="navBlocks">
          <!-- 暂时去掉 :class="navActive(item.links)" active效果，因为其他页不需要显示跳转的列表-->
          <div
            class="navBlock"
            v-for="(item, index) in navsShow"
            :key="index"
            @click="goNewLink(item.links)"
          >
            <div
              style="padding: 0 25px; border-right: 1px #6990aa solid"
              :style="{
                borderRight:
                  navsShow.length - 1 === index
                    ? userName
                      ? '1px #6990aa solid'
                      : ''
                    : '1px #6990aa solid',
              }"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div>
          <span class="userName">{{ userName }}</span>
        </div>
        <div class="avatarBlock">
          <el-dropdown
            class="avatar-container"
            placement="bottom"
            trigger="click"
          >
            <div class="avatar-wrapper">
              <img src="../../assets/outherHome/login.png" alt="" />
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <el-dropdown-item>
                <span v-if="!isLogin" @click="login"> 登录 </span>
                <span v-else @click="logout">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="avatarBlock">
          <el-dropdown
            class="avatar-container twoPopper"
            placement="bottom"
            trigger="click"
          >
            <div class="avatar-wrapper">
              <img src="../../assets/outherHome/order.png" alt="" />
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <!-- <el-dropdown-item> 12312312 </el-dropdown-item> -->
              <div class="listT">
                <div class="listTitle">
                  <span class="listTitleL">产品名称</span>
                  <span class="listTitleR">订购状态</span>
                </div>
                <div class="listContent">
                  <div
                    v-for="(item, index) in lists"
                    :key="index"
                    class="listContentRow"
                  >
                    <span
                      :class="
                        item.isFirst == 1
                          ? 'listContentcol listContentFirst'
                          : 'listContentcol listContentSecond'
                      "
                      >{{ item.levelName }}</span
                    >
                    <span
                      :class="
                        item.purchaseDetails == '未订购'
                          ? 'listContentcol2 listContentNon'
                          : 'listContentcol2 listContentBuy'
                      "
                      @click="gotoLinks(item.purchaseDetails, item.link)"
                      >{{ item.purchaseDetails }}</span
                    >
                  </div>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="avatarBlock" v-if="isDropdownShow()">
          <el-dropdown
            class="avatar-container"
            placement="bottom"
            trigger="click"
          >
            <div class="avatar-wrapper">
              <i class="iconfont iconliebiao" />
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <a target="_blank" href="/details/1">
                <el-dropdown-item> 系统介绍 </el-dropdown-item>
              </a>
              <a target="_blank" href="/detail/explain">
                <el-dropdown-item> 指标解释 </el-dropdown-item>
              </a>
              <a target="_blank" href="/detail/help">
                <el-dropdown-item> 帮助文档 </el-dropdown-item>
              </a>
              <a target="_blank" href="/projectMv">
                <el-dropdown-item> 使用指南 </el-dropdown-item>
              </a>
              <a
                target="_blank"
                href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserSuggestAdd1.aspx"
              >
                <el-dropdown-item> 意见建议 </el-dropdown-item>
              </a>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { LOGIN_URL } from "../../utils/lang";
import { removeToken } from "../../utils/auth";
import { getOrderDetail } from "@/api/index.js";
export default {
  name: "AppHeaderOther",
  data() {
    return {
      showShuoming: false,
      showHelp: false,
      type: "1",
      detail: {},
      url: LOGIN_URL(),
      routeName: "",
      activeList: {
        rcep: [
          // { name: "首页", links: "/rcep/home" },
          { name: "数据查询", links: "/rcep/data" },
          { name: "监测分析", links: "/monitor/overview" },
          { name: "国别报告", links: "/report" },
        ],
        cptpp: [
          // { name: "首页", links: "/cptpp/home" },
          { name: "数据查询", links: "/cptpp/data" },
          { name: "监测分析", links: "/monitor/overview" },
          { name: "国别报告", links: "/report" },
        ],
        chplt: [
          // { name: "首页", links: "/chplt/home" },
          { name: "数据查询", links: "/chplt/data" },
          {
            name: "监测分析",
            links: "/chplt/monitor/tradeOverview/tradeTotal",
          },
          { name: "贸易报告", links: "/chplt/report/chpltReport" },
        ],
      },
      activeku: "",
      navsShow: [],
      lists: [],
      myk: "",
    };
  },
  computed: {
    ...mapGetters(["isLogin", "userName"]),
  },
  created() {
    this.getallList();
  },
  mounted() {
    // document.documentElement.style.fontSize =
    //   document.documentElement.clientWidth / 1920 + "px";
    // window.onresize = function () {
    //   document.documentElement.style.fontSize =
    //     document.documentElement.clientWidth / 1920 + "px";
    // };
    let paths = this.$router.history.current.path;
    if (paths == "/rcep/home") {
      this.setlocalStorage("rcep");
    } else if (paths == "/cptpp/home") {
      this.setlocalStorage("cptpp");
    } else if (paths == "/chplt/home") {
      this.setlocalStorage("chplt");
    }
  },
  methods: {
    login() {
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(6);
      } catch (e) {}
      window.location.href = LOGIN_URL();
    },
    titleName() {
      let ku = this.$router.history.current.path.split("/", 2)[1];
      // this.myk = ku ? ku : "base";
      // window.$myk = this.myk;
      // 修改全局数据
      // this.$root.$eventBus.globalData = this.myk;
      // this.routeName = localStorage.getItem("routeName");
      if (ku == "chplt") {
        this.setlocalStorage("chplt");
        this.activeku = "/chplt";
        this.navsShow = this.activeList.chplt;
        document.title = "区域经贸运行监测平台";
        return "区域经贸运行监测平台";
      } else if (ku == "cptpp") {
        this.navsShow = this.activeList.cptpp;
        this.setlocalStorage("cptpp");
        this.activeku = "/cptpp";
        document.title = "CPTPP经贸运行监测平台";
        return "CPTPP经贸运行监测平台";
      } else if (ku == "rcep") {
        this.navsShow = this.activeList.rcep;
        this.setlocalStorage("rcep");
        this.activeku = "/rcep";
        document.title = "RCEP经贸运行监测平台";
        return "RCEP经贸运行监测平台";
      } else {
        document.title = "国际贸易研究及决策支持系统";
        return "国际贸易研究及决策支持系统";
      }
    },
    isDropdownShow() {
      let ku = this.$router.history.current.path.split("/", 2)[1];
      if (this.routeName == "chplt" || ku == "chplt") {
        return false;
      } else if (this.routeName == "cptpp" || ku == "cptpp") {
        return false;
      } else if (this.routeName == "rcep" || ku == "rcep") {
        return false;
      } else {
        return true;
      }
    },
    navActive(links) {
      if (links == "/report") {
        if (this.$router.history.current.path == "/report") {
          return "navActive";
        }
      } else {
        if (
          links.split("/", 3)[2] ==
          this.$router.history.current.path.split("/", 3)[2]
        ) {
          return "navActive";
        }
      }
      // return links==
    },
    goNewLink(newLinks) {
      // this.setlocalStorage(this.routeName);
      this.$router.push({ path: newLinks });
      // this.$router.push(0);
    },
    gotoLinks(flag, link) {
      if (flag == "已订购") {
        // this.$router.push();
        this.$router.push({ path: link });
      } else {
        return;
      }
    },
    async getallList() {
      let news = await getOrderDetail();
      let temp = [];
      for (let index = 0; index < news.data.length; index++) {
        const element = news.data[index];
        temp.push(element);
        if (element.sysOrderList) {
          for (let j = 0; j < element.sysOrderList.length; j++) {
            const sys = element.sysOrderList[j];
            temp.push(sys);
          }
        }
      }
      this.lists = temp;
    },
    logout() {
      let _this = this;
      $.ajax({
        url: "//d.drcnet.com.cn/eDRCnet.common.web/login/login.ashx?flag=logoutp", //initp 查询目前用户登录状态，logoutp 退出登录
        type: "get",
        dataType: "jsonp", //指定服务器返回的数据类型
        jsonpCallback: "showData", //指定回调函数名称
        xhrFields: { withCredentials: true },
        crossDomain: true,
        async: false,
        success: function (data) {
          // //console.log(data)
          removeToken();
          _this.$router.go(0);
          // window.location.href = "/data/goods/asia/china/monthly";
        },
      });
    },
    // toLinks(link) {
    //   //需要删除localstore
    //   localStorage.removeItem("routeName");
    //   this.$router.push({ path: link });
    // },
    setlocalStorage(value) {
      return new Promise((resolve, reject) => {
        sessionStorage.removeItem("routeName");
        sessionStorage.setItem("routeName", value);
        // 如果有其他操作失败，可以调用reject
        // ... your code here
        resolve(); // 当你的操作成功完成时，你应该resolve这个Promise
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.logined {
  color: #48baff !important;
}
.right-menu {
  float: right;
  height: 100%;
  line-height: 50px;
  font-size: 16px;
  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }
}

.app-header {
  padding-right: 0 !important;
  min-width: 1100px !important;
  background-color: rgba(20, 87, 134, 0.8) !important;
}
//重写头样式
.app-header__logo {
  position: relative !important;
  height: 63px !important;
  display: flex;
  align-items: center;
  top: 0px !important;
  margin-top: 0 !important;
  width: 100% !important;
}
.app-header {
  padding-left: 20px !important;
}
.splitLines {
  width: 1px;
  height: 22px;
  background: #ffffff;
  opacity: 0.4;
  margin: 8px 0px 0 16px;
}

::v-deep .app-title {
  position: sticky !important;
  padding: 6px 25px 0 16px;
}
.rightNavs {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  line-height: 18px;
  // padding: 10px 22px 0 0;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  height: 100%;
  .navBlock {
    display: inline-block;
    // width: 86px;
    // padding: 0 25px;
    cursor: pointer;
    padding: 25px 0;
    // height: 42px;
    // border-right: 2px red solid;
  }
  .navActive {
    border-bottom: 2.5px #1a7ec1 solid;
  }
  .userName {
    color: #fff;
    height: 100%;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    display: flex;
    align-items: center;
  }
  .avatarBlock {
    height: 63px;
    width: 70px;
    background: #19679c;
    margin-right: 1px;
  }
  .avatar-container {
    .avatar-wrapper {
      position: relative;
      line-height: 63px;
      width: 70px;
      text-align: center;
      cursor: pointer;
      .iconfont {
        font-size: 24px;
        color: #fff;
        vertical-align: middle;
      }
      img {
        vertical-align: middle;
      }
    }
  }
}
.listT {
  padding: 10px;
  padding-top: 0;
  width: 330px;
  max-height: 700px;
  overflow-x: auto;
  .listTitle {
    background: #f0f3f7;
    border-bottom: 1px solid #ebeef5;
    // width: 28%;
    display: block;
    color: #000;
    font-weight: 700;
    line-height: 42px;
    font-size: 14px;
    .listTitleL {
      width: 70%;
      padding-left: 17px;
      // float: left;
    }
    .listTitleR {
      width: 30%;
      float: right;
    }
  }
  .listContent {
    .listContentRow {
      // border-top: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
      line-height: 32px;
      color: #000;
      font-weight: 700;
      font-size: 13px;
      .listContentcol {
        width: 70%;
        padding-left: 17px;
      }
      .listContentcol2 {
        width: 30%;
        float: right;
      }
      .listContentFirst {
      }
      .listContentSecond {
        padding-left: 34px;
        font-weight: 400;
      }
      .listContentBuy {
        text-decoration: underline;
        color: blue;
        cursor: pointer;
        font-weight: 400;
      }
      .listContentNon {
        color: #ccc;
        font-weight: 400;
      }
    }
  }
}
.listT::-webkit-scrollbar {
  width: 5px;
  border-radius: 20px;
}

.listT::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.listT::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: #888;
}

.listT::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.databaseAll {
  .el-col {
    margin-bottom: 10px;
    border-bottom: 1px solid #f2f2f2;
  }

  .databaseAllTitle {
    padding-bottom: 10px;
    color: #004677;
    font-weight: 600;
    font-size: 15px;
  }
  .databaseAllList {
    display: inline-block;
    margin-bottom: 10px;
    cursor: pointer;
    color: #494949;
  }
}
</style>
